/**
 * This function is used for display Toast msg through out the site with custom message, class & icon
 * Default value set for display timing, classes
 * To add more customization other methods to ToastNotification and set them to init notification 
 */

var notification = new ToastNotification({
  topPos: $('.header-section').innerHeight() + 30,
  classNames: 'active',
  icons: 'icon-clickToCopy', 
  autoClose: true,
  autoCloseTimeout: 3000 
});

function ToastNotification(option) {
  var el = this;
  var toastWrapper = $("<div class='toast-container' aria-hidden='true'><div class='toast-body'><i class='icon'></i><svg class='icon-svg' xmlns='http://www.w3.org/2000/svg' width='21' height='20' fill='none'><path fill='#fff' d='m18 10.833.833-.833-5.797-5.798-1.179 1.179 3.786 3.786H7.167v1.666h8.476l-3.786 3.786 1.179 1.178L18 10.833z'/><path fill='#fff' d='M2.167 2.5h7.5v1.667H3.833v11.666h5.834V17.5h-7.5v-15z'/></svg><span class='toast-message'></span></div></div>");
  var toastAnnouncer = $("<div class='visually-hidden' role='status' aria-live='polite' aria-atomic='true'></div>");

  $('body').append(toastWrapper, toastAnnouncer);

  el.self = toastWrapper;
  el.announcer = toastAnnouncer;
  el.close = this.self.find(".close");
  el.message = el.self.find(".toast-message");
  el.icon = el.self.find(".icon");
  el.top = option.topPos;
  el.classNames = option.classNames;
  el.icons = option.icons;
  el.autoClose =
    typeof option.autoClose === "boolean" ? option.autoClose : false;
  el.autoCloseTimeout =
    option.autoClose && typeof option.autoCloseTimeout === "number"
      ? option.autoCloseTimeout
      : 3000;

  // Methods
  el.reset = function () {
    el.message.empty();
    el.self.removeClass(el.classNames);
  };
  el.show = function (msg, type, icon) {
    el.reset();
    el.self.css("top", el.top);
    el.message.text(msg);
    el.announcer.empty();
    setTimeout(function () {
      el.announcer.text(msg);
    }, 100);
    el.self.addClass(type);
    el.icon.addClass(icon);

    if (el.autoClose) {
      setTimeout(function () {
        el.hide();
      }, el.autoCloseTimeout);
    }
  };
  el.hide = function () {
    el.self.removeClass('animate__fadeInDownToast').addClass('animate__fadeInUpToast');
    setTimeout(() => {
      el.reset();
      el.self.css("top", '');
      el.self.removeClass('animate__fadeInUpToast');
    }, 300);
  };

  el.close.on("click", this.hide);
}

export default {
  init: function (typo, id, icon) {
    notification.show(typo, id, icon);
  },
}  